import React, { useEffect, useState } from 'react';
import Navbar from '../../Navbar/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { addClientDetails, fetchClientData, fetchClientDetails } from '../../../Redux/Config/Action';
import Swal from 'sweetalert2';
import { FaEdit } from 'react-icons/fa';
import "./ClientDetails.css";

const ClientDetails = () => {

    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { clientDetails, clientDataById } = useSelector((store) => store.config);

    const [formData, setFormData] = useState({
        clientName: "",
        clientShortName: "",
        clientEmail: "",
        clientPhoneNo: "",
        clientAddress: "",
        clientLogo: "",
        actionType:"INSERT"
      });

      const clearUserInputFields = () => {
        setFormData(
          {
            clientMasterId: "",
            clientName: "",
            clientShortName: "",
            clientEmail: "",
            clientPhoneNo: "",
            clientAddress: "",
            clientLogo: "",
            actionType:"INSERT"
          },
        );
      };

      const handleShow = () => setShow(true);

      const handleClose = () => {
        clearUserInputFields();
        setShow(false);
      };

    useEffect(() => {
        dispatch(fetchClientDetails(token));
    }, [dispatch, token]);
    

 
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
  };

    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file); // Convert file to Base64
          reader.onloadend = () => {
              setFormData({ ...formData, clientLogo: reader.result });
          };
      }
  };

    const handleEditClient = (clientMasterId) => {
        dispatch(fetchClientData(clientMasterId,token));
        setShow(true);
    };

      useEffect(() => {
        if (clientDataById.masterData) {
          setFormData({
            clientMasterId: clientDataById.masterData.clientMasterId || "",
            clientName: clientDataById.masterData.clientName || "",
            clientShortName: clientDataById.masterData.clientShortName || "",
            clientEmail: clientDataById.masterData.clientEmail || "",
            clientPhoneNo: clientDataById.masterData.clientPhoneNo || "",
            clientAddress: clientDataById.masterData.clientAddress || "",
            actionType: "UPDATE",
          });
        }
      }, [clientDataById.masterData]);
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {
            dispatch(addClientDetails(formData,token))
            .then((response) => {
                if (response.statusMessage === "SUCCESS") {
                dispatch(fetchClientDetails(token));
                handleClose();
                Swal.fire({
                    title: "Success!",
                    text: response.statusDesc,
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                } else {
                Swal.fire({
                    title: "Error!",
                    text: response.statusDesc,
                    icon: "error",
                    confirmButtonText: "OK",
                });
                }
            })
            .catch(() => {
                Swal.fire({
                title: "Error!",
                text: "There was an error initiating the leave details.",
                icon: "error",
                confirmButtonText: "OK",
                });
            });
        }
       
      };


  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

    return (
        <div>
            <Navbar></Navbar>
            <div className="main-content">
        <div className="container-fluid mt-4">
        <div className="card3">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <h5 className="left-header">CLIENT DETAILS</h5>
              <button className="btn btn-primary" onClick={handleShow}
               disabled={clientDetails.clientMaster?.length>0}>
                ADD NEW
              </button>
            </div>

            <table className="table mt-3">
                <thead>
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Short Name</th>
                        <th scope="col">Address</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {clientDetails.clientMaster && clientDetails.clientMaster.length > 0 ? (
                        clientDetails.clientMaster.map((org, index) => (
                        <tr key={index}>
                            <td>{org?.clientName || "-"}</td>
                            <td>{org?.clientShortName || "-"}</td>
                            <td>{org?.clientAddress || "-"}</td>
                            <td>{org?.clientEmail || "-"}</td>
                            <td>{org?.clientPhoneNo || "-"}</td>
                            <td>
                            <Tooltip text="Edit">
                                <button
                                    type="button"
                                    className="btn btn-warning btn-sm me-2"
                                    onClick={() => handleEditClient(org.clientMasterId)}
                                >
                                    <FaEdit />
                                </button>
                            </Tooltip>
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan="4" className="text-center">No data available</td>
                        </tr>
                    )}
                 </tbody>
            </table>
        </div>
      
        {show && <div className="modal-backdrop fade show"></div>}
        <div className={`modal fade client-modal ${show ? "show d-block" : ""}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">Add Client Details</h5>
                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                    <div className="col-md-8">
                        <label className="form-label">Name <span className="text-danger">*</span></label>
                        <input
                        type="text"
                        className="form-control"
                        name="clientName"
                        value={formData.clientName}
                        onChange={handleChange}
                        required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Short Name <span className="text-danger">*</span></label>
                        <input
                        type="text"
                        className="form-control"
                        name="clientShortName"
                        value={formData.clientShortName}
                        onChange={handleChange}
                        required
                        />
                    </div>
                   
                    </div>
                    <div className="row mb-3">
                       <div className="col-md-6">
                        <label className="form-label">Email <span className="text-danger">*</span></label>
                        <input
                        type="email"
                        className="form-control"
                        name="clientEmail"
                        value={formData.clientEmail}
                        onChange={handleChange}
                        required
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Phone Number <span className="text-danger">*</span></label>
                        <input
                        type="number"
                        className="form-control"
                        name="clientPhoneNo"
                        value={formData.clientPhoneNo}
                        onChange={handleChange}
                        required
                        />
                    </div>
                    </div>
                    <div className="row mb-3">
                    <div className="col-md-12">
                        <label className="form-label">Address <span className="text-danger">*</span></label>
                        <textarea
                        className="form-control"
                        rows="3"
                        name="clientAddress"
                        value={formData.clientAddress}
                        onChange={handleChange}
                        required
                        ></textarea>
                    </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-12">
                            <label className="form-label">Upload Logo</label>
                            <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
                        </div>
                    </div>
                    <div className="text-center">
                    <button type="submit" className="btn btn-success">Submit</button>
                    </div>
                </form>
                </div>
            </div>
            </div>
        </div>

        </div>
        </div>
        </div>
        </div>
    );
};

export default ClientDetails;